

















































































import { Component, Vue } from "vue-property-decorator";
import { getPageAPIs } from "@/common/util";
import { DeepLoop } from "@/common/deepLoop/deepLoop";

import { KTVOrderReserveUpdateRecordApi } from "@/common/api/userManage/ktvOrderReserveUpdateRecord";
export const pageApiList = getPageAPIs(KTVOrderReserveUpdateRecordApi);

const defaultForm = {
  order_no: "", // 订单编号
  shop_name: "", // 店铺名称
};

@Component
export default class KtvOrderReserveUpdateRecord extends Vue {
  private reserveUpdateRecordApi: any;

  private deepLoopUtil: any;

  constructor() {
    super();
    this.reserveUpdateRecordApi = new KTVOrderReserveUpdateRecordApi();

    this.deepLoopUtil = new DeepLoop();

    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm),
    };
  }

  private form: any;

  private tablePage: any = {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
  };

  private tableData: any[] = [];

  // 路由带过来的订单编号(从大明星订单列表跳转)
  private get routeOrderNo(): string {
    const { query = {} } = this.$route || {};
    const { order_no = "" } = query as any;

    return order_no ? String(order_no) : "";
  }

  private activated(): void {
    // 每次进入页面以最新跳转参数为准
    if (this.routeOrderNo !== this.form.order_no) {
      this.form.order_no = this.routeOrderNo;
      this.tablePage.pageNo = 1;
    }

    this.getTable();
  }

  private getTable(): void {
    this.reserveUpdateRecordApi.getReserveUpdateRecordList(
      this.getTableListParams(),
      (res: any) => {
        const { data } = res;

        const { list, count, page, prepage } = data || {};

        this.$set(this.tablePage, "totalCount", count);
        this.$set(this.tablePage, "pageNo", page);
        this.$set(this.tablePage, "pageSize", prepage);

        this.tableData = Array.isArray(list) ? list : [];
      },
      () => {},
      false
    );
  }

  private getTableListParams() {
    const form = this.form;

    const tablePage = this.tablePage;

    const {
      order_no, // 订单编号
      shop_name, // 店铺名称
    } = form || {};

    const { pageNo, pageSize } = tablePage || {};

    const outerParams: any = {
      page: pageNo,
      limit: pageSize,
    };

    if (order_no) {
      outerParams.order_no = order_no;
    }

    if (shop_name) {
      outerParams.shop_name = shop_name;
    }

    return outerParams;
  }

  private restForm(): void {
    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm),
    };

    this.search();
  }

  private search(): void {
    this.tablePage.pageNo = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;

    this.getTable();
  }

  private handlePageChange(val: any) {
    this.tablePage.pageNo = val.currentPage;
    this.tablePage.pageSize = val.pageSize;

    this.getTable();
  }
}
